import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import '@modernizr';

import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';


Vue.config.performance = true;
Vue.config.productionTip = false;
sync(store, router);

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
